type TProps = {
  className?: string;
};

export const ArrowRightIcon = ({ className }: TProps) => {
  return (
    <svg
      fill="none"
      height="21"
      viewBox="0 0 21 21"
      width="21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={className}
        clipRule="evenodd"
        d="M15.3501 11.5854H3.19531V9.91868H15.3501L10.1061 4.67461L11.2846 3.49609L18.5405 10.752L11.2846 18.0079L10.1061 16.8294L15.3501 11.5854Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
};
